import { render, staticRenderFns } from "./CruiseTab.vue?vue&type=template&id=2de5ce5a&scoped=true&"
import script from "./CruiseTab.vue?vue&type=script&lang=js&"
export * from "./CruiseTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de5ce5a",
  null
  
)

export default component.exports